const MFA_AUTHENTICATOR_EXAMPLES = [
    'Microsoft Authenticator',
    'Google Authenticator',
];

const MFA_SETUP_INSTRUCTIONS = [
    `Instale um aplicativo autenticador, como ${MFA_AUTHENTICATOR_EXAMPLES.join(' ou ')}.`,
    'Adicione uma nova conta no aplicativo.',
    'Escaneie o QR Code exibido nesta tela.',
    'Informe o código de 6 dígitos exibido pelo aplicativo.',
];

module.exports = {
    MFA_AUTHENTICATOR_EXAMPLES,
    MFA_SETUP_INSTRUCTIONS,
};
